(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("multi-resolution-elevation", [], factory);
	else if(typeof exports === 'object')
		exports["multi-resolution-elevation"] = factory();
	else
		root["multi-resolution-elevation"] = factory();
})(self, function() {
return 